module.exports = [
  {
    //stylers: [{ visibility: "simplified" }]
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [{color: '#000000'}]
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.stroke',
    stylers: [{
      color: '#ffffff',
      visibility: 'on',
    }]
  }, {
    featureType: 'landscape',
    stylers: [{color: '#f3f3f3'}]
  },
  {
    featureType: 'landscape',
    elementType: 'labels',
    stylers: [{visibility: 'off'}]
  },
  {
    featureType: 'poi',
    stylers: [{visibility: 'off'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#ffffff'}]
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{visibility: 'off'}]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{color: '#ffffff'}]
  },
  {
    featureType: 'water',
    stylers: [{color: '#00b6e4'}]
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [{visibility: 'off'}]
  },
];
